import { AlertTriangleIcon } from "lucide-react";
import { SubmitHandler, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useAccounts } from "../../../hooks/useAccounts";
import strings from "../../../i18n/i18nStrings";
import { SimpleButton } from "../../formComponents/SimpleButton";
import Modal from "../modal/Modal";

const AddAccountModal = ({ onClose }: { onClose: () => void }) => {
  const { createAccount, mutate } = useAccounts();

  interface FormValues {
    name: string;
    email: string;
  }

  const {
    register,
    handleSubmit,
    formState: { errors, isDirty },
  } = useForm<FormValues>({
    defaultValues: {
      name: "",
      email: "",
    },
  });

  const onSubmit: SubmitHandler<FormValues> = async (data) => {
    // Stub out the onSubmit logic
    console.log(data);
    await createAccount(data.name, data.email);
    mutate();
    onClose();
    toast.success(`Account Created. ${data.email} has been invited`);
  };

  //   const onSubmitUser = () => {
  //     if (userName && userEmail) {
  //       handleAddUser(userName, userEmail, () => {
  //         setNotification(
  //           strings.usersPage.modal.successTitle,
  //           strings.usersPage.modal.successMessage(userName)
  //         );
  //         onClose();
  //       });
  //     }
  //   };

  return (
    <Modal title={strings.admin.modal.addAccount} onClose={onClose}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <p className="text-sm font-medium text-gray-900 mb-4">
          {strings.admin.modal.addAccountDescription}
        </p>

        <div className="mb-4">
          <label
            htmlFor="name"
            className="px-0 py-4 text-left text-xs font-bold text-gray-700 uppercase tracking-wider"
          >
            {strings.admin.modal.nameLabel}
          </label>
          <input
            type="name"
            id="name"
            {...register("name", {
              required: true,
            })}
            className={`mt-1 block w-full ${
              errors.name ? "border-2 border-red-500" : "border border-gray-300"
            } rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm`}
            placeholder={strings.admin.modal.namePlaceholder}
          />
          {errors.name && (
            <div className="flex items-center text-red-700 mt-2">
              <AlertTriangleIcon className="w-4 h-4 mr-2" />
              <span className="font-bold text-xs">
                {strings.admin.modal.invalidName}
              </span>
            </div>
          )}
        </div>

        <div className="mb-4">
          <label
            htmlFor="email"
            className="px-0 py-4 text-left text-xs font-bold text-gray-700 uppercase tracking-wider"
          >
            {strings.admin.modal.emailLabel}
          </label>
          <input
            type="email"
            id="email"
            {...register("email", {
              required: true,
              pattern: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
            })}
            className={`mt-1 block w-full ${
              errors.email
                ? "border-2 border-red-500"
                : "border border-gray-300"
            } rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm`}
            placeholder={strings.admin.modal.emailPlaceholder}
          />
          {errors.email && (
            <div className="flex items-center text-red-700 mt-2">
              <AlertTriangleIcon className="w-4 h-4 mr-2" />
              <span className="font-bold text-xs">
                {strings.admin.modal.invalidEmail}
              </span>
            </div>
          )}
        </div>
        <div className="flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="mr-3 px-4 py-2 text-sm font-semibold underline text-blue-700 hover:text-blue-800"
          >
            {strings.common.cancel}
          </button>
          {/* Dirty: {isDirty ? "yes" : "no"} */}
          <SimpleButton type="submit" disabled={!isDirty}>
            Submit
          </SimpleButton>
        </div>
      </form>
    </Modal>
  );
};

export default AddAccountModal;
